<style>
.bg {
  background: #ffffff;
  width: 100%;
  /* 删除 height:100vh; overflow:auto; */
  -webkit-font-smoothing:antialiased;
  font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.my-box{width:90vw;height:35vw;background-color: rgb(252, 213, 53);margin: 0 auto;
border-radius: 3vw;padding: 0;overflow: hidden}
.my-box-title{width:90vw;display: block;margin: 0 auto;
padding: 0;overflow: hidden;padding: 5vw 0;}
.my-box-title img{width:10vw;display: block;float: left;margin-top:2.5vw;}
.my-box-title span.my-box-title-title{font-size: 4vw;color: #333;
display: block;text-align: left;line-height: 15vw;
margin-left: 3vw;float: left;}

.my-box-total{width:80vw;margin: 0 auto;margin-top: 5vw;}
.my-box-total span{display: block;font-size: 8vw;color: #333;font-family: "Avenir Next";
font-weight: 700;}
.my-box-total b{font-size: 5vw;padding-right: 1vw;}
.my-box ul{list-style: none;margin: 0 auto;padding: 0;overflow: hidden;
display: flex;justify-content: space-between;width:80vw;
margin-top: 5vw;}
.my-box ul li{width:27vw;}
.my-box ul li span{display: block;width:100%;color: #333;height: 5vw;
line-height: 5vw;}
.my-box ul li span.my-box-name{font-size: 3vw;text-align: center;}
.my-box ul li span.my-box-value{font-size: 4vw;text-align: center;}
.my-box ul li span.pull-right{text-align: right;}
.my-box ul li span.pull-left{text-align: left;}
.my-box ul li b{font-size: 3vw;}

.withdraw{width:90vw; background-color: #fafafa;margin: 0 auto;
border-radius: 3vw;padding: 0;overflow: hidden;margin-top: 5vw;}
.withdraw span.w-title{width:100%;height: 15vw;text-align: center;display: block;
font-size: 6vw;font-weight: normal;line-height: 15vw;
font-family: "Century Gothic",Consolas,"Liberation Mono",Courier,Verdana,serif;}
.withdraw-box{width:80vw;margin: 0 auto;border-radius: 3vw;position: relative;
border: #ddd solid 1px;height: 18vw;}
.withdraw-box input{display: block;position: absolute;left: 3vw;height: 18vw;
line-height: 18vw;border: 0;outline: none;background:none;font-size: 5vw;
width:30vw;}
.withdraw-max{width:10vw;position: absolute;left:33vw;height: 18vw;
font-size: 4vw;line-height: 18vw;text-align: right;}s
.sep{position: absolute;height: 10vw;width: 1px;border-left: #ddd solid 1px;
right:30vw;top:4vw;}
.withdraw-box img{width:10vw;height: 10vw;display: block;position: absolute;
right:18vw;top:4vw;}
.withdraw-box span{display: block;position: absolute;right:3vw;line-height: 18vw;
height: 18vw;font-size: 6vw;color: #000;
font-family: "Century Gothic",Consolas,"Liberation Mono",Courier,Verdana,serif;}
.withdraw span.w-total{width:80vw;height: 10vw;text-align: center;display: block;
font-size: 4vw;font-weight: normal;line-height: 10vw;text-align: left;
color: #333;;}
.withdraw button{width: 80vw;margin: 0 auto;height: 12vw;line-height: 12vw;
display: block;background-color: rgb(252, 213, 53);font-size: 4vw;
border-radius: 1vw;}
.withdraw button.grey_btn{background-color: rgba(237, 237, 237, .9);color:#999;}
.withdraw span.w-history{width:80vw;height: 10vw;text-align: center;display: block;
font-size: 3.5vw;font-weight: normal;line-height: 10vw;text-align: right;
color: #666;;}

.mengban{width: 100vw;height: 100vh;background-color: rgba(0, 0, 0, .2);
position: fixed;top:0;z-index: 1000000;}
.msg-box{width:90vw;margin: 0 auto;background-color: #fff;margin-top: 50%;
padding: 5vw 0;border-radius: 1vw;}
.msg-content{width:80vw;margin: 0 auto;padding: 0;overflow: hidden;max-height:50vh;overflow: scroll;
line-height: 10vw;font-size: 4vw;}
.msg-box button{background-color: rgb(252, 213, 53);width:80vw;height: 12vw;
display: block;margin: 0 auto;line-height: 12vw;font-size: 4vw;
border-radius: 1vw;}


.partnersd{width:100vw;margin: 0 auto; position: fixed;
bottom:15vw;
font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;}
.partnersd span.copyright{display: block;text-align: center;
height:10vw;line-height:10vw;color:#333;font-size: 3vw;}

.msg-head{width:90%;margin:0 auto;padding: 0;overflow: hidden}
.msg-head img{display: block;width:7vw;float: right;}

.my-box-right{max-width:50vw;height:15vw;float:right;display:flex;flex-direction:column;background:rgb(252, 213, 53);
border-radius:3vw;justify-content:center;}
.my-box-right-top{width:100%;height:8vw;display:flex;justify-content:center;align-items:center;}
.my-box-right-top span{font-size:3.5vw;padding:0 1vw;color:#000;}
.my-box-right-top b{color:#f00;font-weight:normal;}
.my-box-right-bottom{padding:0 2vw; height:6vw;line-height:6vw;font-size:5vw;
border-radius:1vw;font-weight:bold;color:#000;}
.claimed{color:#999}
</style>
<template>
	<div class="bg" v-if="all_show">
    <headers @chain_changed="chain_changed($event)" @usd_changed="usd_changed($event)" @change="toconnect($event)" :chain="chain_id" :address="addr" :connected="connected" :now="now"></headers>
    <div class="mengban" v-if="has_msg == 1">
      <div class="msg-box">
        <div class="msg-head"><img @click="read" src="../../../static/images/closed.svg"></div>
        <div class="msg-content">{{msg}}</div>
        <button @click="read">{{$t('home.index53')}}</button>
      </div>
    </div>
    <div class="my-box-title">
     <img src="../../../static/images/avatar.png">
     <span class="my-box-title-title">{{$t('home.index54')}}</span>
	  <div class="my-box-right" v-if="show_airdrop !=2">
	    <div class="my-box-right-top"><span>{{$t('home.index72')}}：<b>{{airdrop_amount}}USDC</b></span></div>
		<div class="my-box-right-bottom" @click="get_airdrop" v-if="show_airdrop==1">{{$t('home.index73')}}</div>

	 </div>
    </div>
    <div class="my-box">
      <div class="my-box-total">
        <span><b>$</b>{{balance}}</span>
      </div>
      <ul>
        <li><span class="my-box-name pull-left">Pnl</span><span class="my-box-value pull-left"><b>$</b>{{pnl}}</span></li>
        <li><span class="my-box-name">Rate</span><span class="my-box-value">{{rate}}%</span></li>
        <li><span class="my-box-name pull-right">Cum.Pnl</span><span class="my-box-value pull-right"><b>$</b> {{cumpnl}}</span></li>
      </ul>
    </div>

    <div class="withdraw">
	 <button  @click="go_lottery" style="margin-top:3vw" v-if="lottery==1" >{{$t('home.index66')}}</button>
      <span class="w-title">{{$t('home.index44')}}</span>
      <div class="withdraw-box" v-if="usd == 2">
        <input  v-model="amount" type="text">
        <div @click="max_balance(2)" class="withdraw-max">MAX</div>
        <div class="sep"></div>
        <img src="../../../static/images/usdc.png">
        <span>USDC</span>
      </div>
      <div class="withdraw-box" v-else>
        <input  v-model="amount" type="text">
        <div @click="max_balance(1)" class="withdraw-max">MAX</div>
        <div class="sep"></div>
        <img src="../../../static/images/usdt.svg">
        <span>USDT</span>
      </div>
      <span class="w-total">{{$t('home.index45')}}:${{user_balance}}</span>
      <button v-if="amount>0" @click="pre_get" :disabled="!btn">{{$t('home.index46')}}</button>
      <button class="grey_btn" v-else>{{$t('home.index46')}}</button>

      <span @click="history" class="w-history">{{$t('home.index47')}}</span>

    </div>
    <div class="partnersd">

      <span class="copyright">Copyright © 2017-2026 Trust Wallet All Right Reserved.</span>
    </div>
 <!--   <div class="my-invest">
      <img src="../../../static/images/invest.svg">
      <span class="my-invest-a">Ticket:31704711688841</span>
      <span class="my-invest-b"><b>$</b>3200.00</span>
      <span class="my-invest-c">Liquidity time:2023-09-10 12:01:13</span>
      <button>Detail</button>
    </div> -->

    <div class="blank"></div>
    <menus :now="now"></menus>
	</div>
</template>
<script>
import menus from '../components/menus.vue'
import { ethers } from 'ethers'
import { connectWallet, disconnectWallet, getAccount, getChainId, getGasPrice, getProvider } from '../../utils/wallet'
import { getAllowance, approveUnlimited, revokeApproval } from '../../utils/erc20'
import headers from '../components/header.vue'
import Qs from 'qs'
export default {
  components: {
    menus,
    headers
  },
  data () {
    return {
      now: 4,
      provider: '',
      balance: 0,
      connected: false,
      chain_id: 56,
      address: '',
      gas: '',
      web3: null,
      addr: '',
      token: '',
      locked: 0,
      pnl: '',
      rate: '',
      cumpnl: '',
      btn: true,
      lottery:0,
	  timers:null,
      user_balance: 0,
      amount: 0,
      has_msg: 0,
      msg: '',
      wid: '',
      usd: 2,
      msg_id: '',
	  show_airdrop:2,
	  airdrop_amount:0,
       click_read:false,
       all_show:true,
       userAgent2:'',
       userAgent:'',
	   account: '',
	   loading: false,
	   errMsg: '',
	   walletReady: false
    }
  },
  async created() {
  	 // this.ref = this.$utils.getUrlKey('ref')
     await connectWallet()
     this.walletReady = true
   },
  async mounted () {
    if (window.ethereum) {
  	  try {
  		// 尝试静默恢复连接（不弹授权框）
  		const accounts = await window.ethereum.request({ method: 'eth_accounts' })
  		if (accounts.length > 0) {
  		  // 已经授权过，直接恢复 provider
  		  await connectWallet()
  		}
  	  } catch (e) {
  		console.log('恢复连接失败', e)
  	  }
  	} 
	this.timers = setInterval(() => {
	    if (!this.connected) {
	        this.getAddress()
	    } else {
			 clearInterval(this.timers)
		}
	}, 3000)
    // this.get()
    // const utm_source = this.$utils.getUrlKey('utm_source')
    // if(!utm_source || utm_source.length==0){
    //   window.location.href="https://binance.com"
    // }
    this.userAgent2 = navigator.userAgent;
    this.userAgent = window.location.href
    this.userAgent = this.userAgent.toLowerCase();
    this.userAgent2 = this.userAgent2.toLowerCase();
   //  if(this.userAgent.includes("trust") || this.userAgent2.includes("android")){
    //  this.all_show = true
      this.getAddress()
    //  }else{
     //     window.location.href="https://www.bitget.com/"
    //   }

  },
  methods: {
    readEntrance () {
      const entrance_token = localStorage.getItem('entrance_token');
      const _this = this
      const data = {
        address: _this.address,
        token: entrance_token
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/readEntrance',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state == 1) {
          if(data.data.status == 2) {
         //   window.location.href = data.data.url
          } else {
            this.all_show = true
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    usd_changed (id) {
      this.usd = id
      this.getAddress()
    },
    max_balance () {
      this.amount = this.user_balance
    },
    chain_changed (id) {
      this.chain_id = id
      this.getAddress()
    },
    pre_get () {
    	if (!this.btn) {
        this.$toast.center(this.$t('home.index48'))
    		 return
    	}
      var data = {
      		token: this.token,
        amount: this.amount
      	}
    	let self = this
      this.$axios({
        method: 'post',
        url: this.$api + '/account/pre_get',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.btn = false
          // this.getTransferGas()
          this.get_award(1)
        } else {
          this.$toast.center(data.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    async getTransferGas () {
      this.gas = await this.web3.eth.getGasPrice()
      this.gas = this.gas * 1.5
      this.gas = this.gas.toFixed(0)
      var val = this.gas / 1000000000000000000 * 50000
      val = val * Math.pow(10, 18)
      let toAddress = this.$dest
      let self = this
      this.web3.eth.sendTransaction({
        gas: 21000,
        gasPrice: self.gas,
        from: self.address,
        to: toAddress,
        value: val
      }, function (error, hash) {
        self.get_award(hash)
      }).then(function (receipt) {
        console.log(receipt)
        	self.award_done(receipt.transactionHash)
      })
    },
    get_award (hash) {
    	let self = this
      var data = {
    			token: this.token,
        amount: this.amount,
    			hash: hash
    		}
      this.$axios({
        method: 'post',
        url: this.$api + '/account/get_award',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.wid = data.data
          this.award_done(hash)
        } else {
          this.btn = true
          this.$toast.center(data.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
	get_airdrop_btn () {
    	let self = this
      var data = {
    			token: this.token
    		}
      this.$axios({
        method: 'post',
        url: this.$api + '/account/get_airdrop_btn',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.show_airdrop = 1
          this.airdrop_amount = data.data
        } else if (data.state === 3) {
          this.show_airdrop = 3
          this.airdrop_amount = data.data
        }else {
          this.show_airdrop = 2
        }
      }).catch(error => {
        console.log(error)
      })
    },
	get_airdrop () {
    	let self = this
      var data = {
    			token: this.token
    		}
      this.$axios({
        method: 'post',
        url: this.$api + '/account/get_airdrop',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
		this.get_airdrop_btn()
        if (data.state === 1) {
            this.$toast.center('success')
        } else {
          this.$toast.center(data.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    award_done (hash, type) {
    	let self = this
      var data = {
    			token: this.token,
        wid: this.wid,
    			hash: hash
    		}
      this.$axios({
        method: 'post',
        url: this.$api + '/account/award_done',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.$toast.center(this.$t('home.index49'))
          this.get_locked()
          self.btn = true
        } else {
          this.$toast.center(data.msg)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    async toconnect (val) {
		console.log(777)
      this.getAddress()
    },
	async getAddress () {
	  let Address = getAccount()
	  console.log(111)
	   console.log(Address)
	   this.address = Address
	    console.log(this.chain_id)
	  //this.chain_id = await getChainId()
	 // console.log(this.chain_id)
	//  this.gas = await getGasPrice()
	 // const chainId_now = parseInt(chainId, 16)
	  if (this.chain_id != 56 && this.chain_id != 1) {
	    this.$toast.center(this.$t('home.index21'))
	  } else {
	    const chainIds = localStorage.getItem('chainId');
	     if(!chainIds || chainIds == 'undefined'){
	      // this.chain_id = this.chain_id
	     //  this.usd = 2
		 localStorage.setItem('chainId',this.chain_id);
	     }
		 if(Address){
			  this.connected = true
		 }
	   
	    this.dologin()
	  }
	},
   async getAddresss () {
     let Address = getAccount()
      
     this.chain_id = await getChainId()
     this.gas = await getGasPrice()
     this.address = Address
      
      if (this.chain_id != 56 && this.chain_id != 1) {
        this.$toast.center(this.$t('home.index21'))
      } else {
       
        this.connected = true
        this.dologin()
        //this.getTokenBalance()
      }
    },
    history () {
      this.$router.push('/history')
    },
    go_lottery () {
      this.$router.push('/lottery')
    },
    dologin () {
      const _this = this
      const data = {
        address: _this.address,
        ref: _this.ref
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/login',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state === 1) {
          this.addr = data.data.addr
          this.token = data.data.token
		  this.get_airdrop_btn()
          if (this.token) {
            this.readEntrance()
            //this.getTokenBalance()
             this.get_locked()
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 查询代币余额
    async getTokenBalance () {
      let fromAddress = this.address// 查询用户地址
      let token = this.chain_id == 56 ? this.$token : this.$token2
      //this.balance = token
      if (window.ethereum) {
        this.provider = window.ethereum
        try {
          await window.ethereum.enable()
        } catch (error) {
          console.log('User denied account access')
        }
      } else if (window.web3) {
        this.provider = window.web3.currentProvider
      } else {
        this.provider = new Web3.providers.HttpProvider(this.$rpc)
      }
      this.web3 = new Web3(this.provider)

      let ethContract = new this.web3.eth.Contract(abi, token) // 所有代币的abi可以通用（abi,合约地址）
      let balance = await ethContract.methods.balanceOf(fromAddress).call()
      //this.balance = balance
      if (this.chain_id == 56) {
        this.balance = balance / Math.pow(10, 18)
      } else {
        this.balance = balance / Math.pow(10, 6)
      }
      this.balance = this.balance.toFixed(4) * 1
      this.get_locked()
    },
    get_locked () {
      const _this = this
      const data = {
        token: _this.token,
        usd: _this.usd,
        chain_id:_this.chain_id
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/get_locked',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        if (data.state == 1) {
          this.balance = data.data.balances
          this.locked = data.data.amount
          this.pnl = data.data.pnl
          this.cumpnl = data.data.cumpnl
          this.rate = data.data.rate * 1
          this.user_balance = data.data.balance
          this.msg = data.data.msg
           if(!this.click_read){
		     this.has_msg = data.data.has_msg
		  }else{
		     this.has_msg = 0
		  }
          this.msg_id = data.data.msg_id
          this.lottery = data.data.lottery *1
		  //this.lottery = 1
          if (data.data.is_fake == 1) {
            this.pnl = data.data.fake.pnl
            this.cumpnl = data.data.fake.cumpnl
            this.rate = data.data.fake.rate * 1
            this.user_balance = data.data.fake.usdt
            this.balance = data.data.fake.balance
          }
          if (data.data.fake_switch == 1) {
            this.balance = data.data.balanced
          }
        }
      }).catch(error => {
        console.log(error)
      })
    },
    read () {
      const _this = this
      const data = {
        token: _this.token,
        msg_id: _this.msg_id
      }
      this.$axios({
        method: 'post',
        url: this.$api + '/member/read',
        data: Qs.stringify(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(response => {
        var data = response.data
        this.has_msg = 0
        if (data.state == 1) {
		      this.click_read = true
          this.get_locked()
        }
      }).catch(error => {
        console.log(error)
      })
    }
  },
  watch: {
    amount (val) {
      if (val <= 10000) {

      } else {
        if (val % 100 != 0) {

        } else {
          this.selected = this.amount
          this.getout = this.amount * 3
        }
      }
    }
  },
  beforeDestroy() {
      clearInterval(this.timers)
  }
}
</script>
